import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { BankAccountTypeDisplay } from '../../../models/enums';

// This used to import these types from the financing-mk0-services library, which broke the direction of dependency, and indicates this component is likely not meant for common-ui.
export enum BankAccountType {
    /** 0 */
    UNKNOWN_BANK_ACCOUNT_TYPE = 'UNKNOWN_BANK_ACCOUNT_TYPE',
    /** 1 */
    ACH = 'ACH',
    /** 2 */
    WIRE = 'WIRE'
}
export class RedactedBankAccount {
    public bankAccountKey: string;
    public bankName: string;
    public accountName: string;
    public redactedAccountNumber: string;
    public isDefault: boolean;
    public isVerified: boolean;
    public bankAccountType: BankAccountType;
    public routingNumber: string;
    constructor(obj?: {
        bankAccountKey?: string;
        bankName?: string;
        accountName?: string;
        redactedAccountNumber?: string;
        isDefault?: boolean;
        isVerified?: boolean;
        bankAccountType?: BankAccountType;
        routingNumber?: string;
    }) {
        if (obj != null) {
            this.bankAccountKey =
                typeof obj.bankAccountKey === 'undefined'
                    ? this.bankAccountKey
                    : obj.bankAccountKey;
            this.bankName = typeof obj.bankName === 'undefined' ? this.bankName : obj.bankName;
            this.accountName =
                typeof obj.accountName === 'undefined' ? this.accountName : obj.accountName;
            this.redactedAccountNumber =
                typeof obj.redactedAccountNumber === 'undefined'
                    ? this.redactedAccountNumber
                    : obj.redactedAccountNumber;
            this.isDefault = typeof obj.isDefault === 'undefined' ? this.isDefault : obj.isDefault;
            this.isVerified =
                typeof obj.isVerified === 'undefined' ? this.isVerified : obj.isVerified;
            this.bankAccountType =
                typeof obj.bankAccountType === 'undefined'
                    ? this.bankAccountType
                    : obj.bankAccountType;
            this.routingNumber =
                typeof obj.routingNumber === 'undefined' ? this.routingNumber : obj.routingNumber;
        }
    }
}

@Component({
    selector: 'bank-account-card',
    template: `
        <div class="bank-account-card">
            <div class="bank-account-info">
                <div class="bank-account-badges">
                    <div
                        *ngIf="bankAccount.isVerified"
                        class="bank-account-badge badge-verified"
                        i18n="Verified bank account label"
                    >
                        Verified
                    </div>
                    <div
                        *ngIf="!bankAccount.isVerified"
                        class="bank-account-badge badge-pending"
                        i18n="Pending bank account label"
                    >
                        Pending
                    </div>
                    <div
                        *ngIf="bankAccount.isDefault"
                        class="bank-account-badge badge-default"
                        i18n="Default bank account label"
                    >
                        Default
                    </div>
                </div>
                <div class="bank-account-type">
                    {{
                        bankAccount.bankAccountType
                            ? bankAccountTypeDisplay[bankAccount.bankAccountType]
                            : bankAccountTypeDisplay['ACH']
                    }}
                </div>
                <div class="bank-account-details">
                    <div class="bank-account-detail row">
                        <div class="col-6 title">
                            Account Name
                        </div>
                        <div class="col-6 content">
                            <lsq-truncate
                                [value]="bankAccount.accountName"
                                [maxLength]="15"
                            ></lsq-truncate>
                        </div>
                    </div>
                    <div class="bank-account-detail row">
                        <div class="col-6 title">
                            Account Number
                        </div>
                        <div class="col-6 content">
                            {{ bankAccount.redactedAccountNumber }}
                        </div>
                    </div>
                    <div *ngIf="bankAccount.routingNumber" class="bank-account-detail row">
                        <div class="col-6 title">
                            ABA / Routing Number
                        </div>
                        <div class="col-6 content">
                            <lsq-truncate
                                [value]="bankAccount.routingNumber"
                                [maxLength]="15"
                            ></lsq-truncate>
                        </div>
                    </div>
                    <div class="bank-account-detail row">
                        <div class="col-6 title">
                            Bank Name
                        </div>
                        <div class="col-6 content">
                            <lsq-truncate
                                [value]="bankAccount.bankName"
                                [maxLength]="15"
                            ></lsq-truncate>
                        </div>
                    </div>
                </div>
                <div class="bank-account-actions row">
                    <div
                        class="action set-default col-6"
                        *ngIf="bankAccount.isVerified && !bankAccount.isDefault"
                    >
                        <lsq-button
                            appearance="transparent"
                            i18n="Edit bank account button"
                            [style.display]="'flex'"
                            (buttonClick)="setDefaultClick.emit()"
                        >
                            Set Default
                        </lsq-button>
                    </div>
                    <div class="action remove-account col-6">
                        <lsq-button
                            appearance="transparent"
                            i18n="Remove bank account button"
                            [style.display]="'flex'"
                            (buttonClick)="removeClick.emit()"
                        >
                            Remove Account
                        </lsq-button>
                    </div>
                </div>
            </div>
        </div>
    `,
    styleUrls: ['./bank-account-card.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class BankAccountCardComponent {
    @Input() public bankAccount: RedactedBankAccount;
    @Output() public setDefaultClick = new EventEmitter();
    @Output() public removeClick = new EventEmitter();

    constructor(public bankAccountTypeDisplay: BankAccountTypeDisplay) {}
}
